/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import autoTemplateComponent from './core/auto-template-component' // Automatically includes JS from get_template_component
import menuMenu from '../../components/header/nav-primary/nav-primary'
import search from '../../components/global/site-search'
import toggleableElement from './utilities/toggle'

window.addEventListener('DOMContentLoaded', () => {
  menuMenu({
    container: 'js-nav-primary',
  })

  search()

  autoTemplateComponent()

  window.langSwitcher = toggleableElement({
    button: '#js-lang-switcher-btn',
    dropdown: '#js-lang-switcher-dd',
    hiddenClass: 'hidden',
  })

  if (document.querySelector('[data-tippy-content]')) {
    import('./libraries/tippy').then((module) => module.default())
  }

  const filters = () => {
    const form = document.getElementById('js-filter-form')
    const formReset = document.getElementById('js-filter-form-reset')

    if (!form || !formReset) return

    formReset.addEventListener('click', (e) => {
      // clear input values
      const inputs = form.elements

      if (!inputs?.length) return

      for (i = 0; i < inputs.length; i++) {
        inputs[i].value = ''
      }

      // remove query string from url
      window.history.replaceState(null, null, window.location.pathname)

      // hide the filter reset btn
      formReset.classList.add('hidden')
    })

    window.addEventListener('load', (e) => {
      // page has been filtered
      if (window?.location?.search?.length) {
        formReset.classList.remove('hidden')
      }
    })

    // form elements have changed
    form.addEventListener('input', (e) => formReset.classList.remove('hidden'))
  }

  filters()
})
